
import { Component, Emit, Vue } from "vue-property-decorator";
import { Nullable, PhoneNumber, PhoneNumberType } from "@gsx/common";
import FormSelect from "../../../form/FormSelect.vue";
import ActionButton from "../../../../../../common/src/components/ActionButton.vue";
import Modal from "../../../../../../common/src/components/Modal.vue";
import FormTel from "../../../form/FormTel.vue";
import FormTextarea from "../../../form/FormTextarea.vue";

@Component({
    components: {
        FormTextarea,
        FormTel,
        ActionButton,
        FormSelect,
        Modal,
    },
})
export default class AddPhoneNumberModal extends Vue {
    comments: string | null = null;
    phoneNumber: string | null = null;
    type: PhoneNumberType | null = null;

    get phoneNumberTypes(): PhoneNumberType[] {
        return Object.values(PhoneNumberType);
    }

    @Emit()
    submit(): Nullable<PhoneNumber> {
        return {
            comments: this.comments,
            phoneNumber: this.phoneNumber,
            type: this.type,
        };
    }

    @Emit()
    close() {
        //
    }

    async onSubmit() {
        this.submit();
        this.close();
    }
}
